/**
 * Optional-event tick columns and H-brk / S-brk number columns.
 * generate-signup-sheets and the browser both import this file. Do not copy it.
 */

export const DOUBLES_SINGLES = {
  doublesOnly: "doublesOnly",
  optional: "optional",
  always: "always",
};

export const sheetKindFromBowlerQuantity = (bowlerQuantity) => {
  const size = Number(bowlerQuantity) || 1;
  if (size <= 1) return "singles";
  if (size === 2) return "doubles";
  if (size >= 5) return "team5";
  return "team4";
};

export const optionalEventLabel = (event) => {
  const abbreviation = String(
    event?.eventAbbreviation || event?.event_abbreviation || ""
  ).trim();
  if (abbreviation) return abbreviation;
  const name = String(event?.eventName || event?.event_name || "").trim();
  if (name.length > 16) return `${name.slice(0, 14)}…`;
  return name;
};

export const uniqueOptionalEvents = (events) => {
  const seen = new Set();
  const list = [];
  (events || []).forEach((event) => {
    const label = optionalEventLabel(event);
    const key = label.toLowerCase();
    if (!label || seen.has(key)) return;
    seen.add(key);
    list.push({
      id: event?.id || label,
      label,
    });
  });
  return list;
};

export const isSinglesLikeEvent = (event, singlesEvent) => {
  if (!event) return false;
  const left = String(event.eventName || "").trim().toLowerCase();
  if (!singlesEvent) return left === "singles";
  if (event.id && event.id === singlesEvent.id) return true;
  const right = String(singlesEvent.eventName || "").trim().toLowerCase();
  return Boolean(left && left === right);
};

export const applyDoublesSinglesOption = ({
  optionalEvents,
  singlesEvent,
  mode,
}) => {
  const rest = (optionalEvents || []).filter(
    (event) => !isSinglesLikeEvent(event, singlesEvent)
  );
  if (mode === DOUBLES_SINGLES.optional && singlesEvent) {
    return [singlesEvent, ...rest];
  }
  return rest;
};

export const printSinglesEventFromEvents = (events) =>
  (events || []).find(
    (event) =>
      event &&
      event.isDeleted !== true &&
      (event.isPrimary === true || event.isPrimary === "true") &&
      Number(event.bowlerQuantity) === 1
  ) || null;

export const printedOptionalTickEvents = ({
  bowlerQuantity,
  optionalEvents,
  singlesEvent,
  doublesSingles,
} = {}) => {
  const kind = sheetKindFromBowlerQuantity(Number(bowlerQuantity) || 1);
  const pots =
    kind === "doubles"
      ? applyDoublesSinglesOption({
          optionalEvents: optionalEvents || [],
          singlesEvent,
          mode: doublesSingles,
        })
      : optionalEvents || [];
  return uniqueOptionalEvents(pots);
};

export const printedOptionalTickLabels = (options) =>
  printedOptionalTickEvents(options).map((event) => event.label);

export const PRINTED_BRACKET_COL = {
  handicap: { scoringMode: "handicap", key: "hBrk", label: "H-brk" },
  scratch: { scoringMode: "scratch", key: "sBrk", label: "S-brk" },
};

const scoringModeOf = (item) => {
  if (typeof item === "string") return item.trim().toLowerCase();
  return String(item?.scoringMode || "").trim().toLowerCase();
};

export const isPrintedBracketHeader = (value) => {
  const text = String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[\s_]+/g, "-");
  return (
    text === "h-brk" ||
    text === "s-brk" ||
    text === "hbrk" ||
    text === "sbrk"
  );
};

export const printedBracketColumns = (productsOrModes) => {
  const modes = new Set();
  (productsOrModes || []).forEach((item) => {
    if (item && typeof item === "object" && item.isDeleted === true) return;
    const mode = scoringModeOf(item);
    if (mode === "handicap" || mode === "scratch") modes.add(mode);
  });
  const cols = [];
  if (modes.has("handicap")) cols.push(PRINTED_BRACKET_COL.handicap);
  if (modes.has("scratch")) cols.push(PRINTED_BRACKET_COL.scratch);
  return cols;
};

export const printedBracketModes = (productsOrModes) =>
  printedBracketColumns(productsOrModes).map((col) => col.scoringMode);
